<template>
  <v-tabs v-model="tab" dense>
    <v-tabs-slider></v-tabs-slider>
    <v-tab v-for="(v, i) in tabs" :key="i" :to="v.to">
      {{ v.text }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  props: {
    quoteId: String,
  },
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    tabs() {
      if (!this.quoteId) return [];
      return [
        {
          text: "Quote",
          to: { name: "quotes_view" },
        },
        {
          text: "Overview",
          to: { name: "quotes_overview" },
        },
        {
          text: "Program",
          to: { name: "quotes_program" },
        },
        {
          text: "Documents",
          to: { name: "quotes_documents" },
        },
      ];
    },
  },
};
</script>
